import { Text } from "@chakra-ui/react";
import { StatusCellProps } from "../types";

export function StatusCell({ status, textColor }: StatusCellProps) {
  return (
    <Text
      color={textColor}
      fontSize="14px"
      lineHeight="24px"
      fontWeight="400"
      width="fit-content"
      height={"34px"}
      whiteSpace="nowrap"
      borderRadius="100px"
      padding="5px 15px"
      bgColor="#F3F5F5"
      textTransform="capitalize"
    >
      {status}
    </Text>
  );
}
